import { FIELD_XXS } from "../../helpers";
export var MIN_WIDTH_SELECTABLE_TEXT_INPUT = FIELD_XXS;
//# sourceMappingURL=helpers.js.map